export default __webpack_public_path__ + "static/media/trend-up.f5041efd.svg";